module.exports = __webpack_public_path__ + "static/img/er.e5e5e397.svg";